import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { S as d } from "./types-b577bf77.mjs";
function s({
  title: r,
  titleId: e,
  size: i,
  height: a,
  width: c,
  ...h
}) {
  const n = i ? d[i] : d.s;
  return /* @__PURE__ */ o(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: i ? n : a || n,
      width: i ? n : c || n,
      "aria-labelledby": e,
      ...h,
      children: [
        r ? /* @__PURE__ */ l("title", { id: e, children: r }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Warning__Filled_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 51.142c-2.233 0-3.833 1.474-3.833 3.655 0 2.184 1.6 3.704 3.833 3.704 2.23 0 3.833-1.52 3.833-3.704 0-2.181-1.604-3.655-3.833-3.655Zm1.65-3.89c.436-4.558 1.26-17.043 1.26-20.6v-1.9h-5.727v1.9c0 3.557.827 16.042 1.264 20.6h3.203ZM36 6a3.845 3.845 0 0 0-3.327 1.89l-30.67 52.5a3.678 3.678 0 0 0 .016 3.743A3.848 3.848 0 0 0 5.334 66h61.332c1.368 0 2.627-.71 3.315-1.867a3.678 3.678 0 0 0 .015-3.742L39.326 7.89A3.845 3.845 0 0 0 36 6Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Warning__Filled_svg__a", children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
export {
  s as S
};
